import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PricingArea} from '../../../data/pricing-area';
import {Subject, Subscription, timer} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {ProjectCalcService} from '../../../data/project-calc.service';
import {PricingGrade} from '../../../data/pricing-grade';
import {WsUpdateResponce} from '../../../../data/ws-update-responce';
import {WsService} from '../../../../data/ws.service';
import {PricingGroupItem} from '../../../data/group/pricing-group-item';
import {PricingGroup} from '../../../data/group/pricing-group';
import {ProjectPricing} from '../../../data/project-pricing';
import {PricingCategory} from '../../../data/pricing-category';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
  selector: 'app-project-area-view',
  templateUrl: './project-area-view.component.html',
  styleUrls: ['./project-area-view.component.scss']
})
export class ProjectAreaViewComponent implements OnInit, OnDestroy {

  @Input()
  area: PricingArea;

  miscAndAddonsGroups: PricingGroup[] = [];
  groupsWithoutAddons: PricingGroup[] = [];

  @Input()
  pricingId: number;

  @Input()
  boxGrades: PricingGrade[]
  boxGrade: PricingGrade;

  @Input()
  matGrades: PricingGrade[]

  areaUpdateSubj: Subscription;
  nameUpdateSubj = new Subject();

  sumValueSubj: Subscription;
  sumValue: number | null = 0;
  sumValueQty: number | null = 0;

  areaName = 'New Area'

  wsSub: Subscription;

  @Output()
  deleteAreaEmitter = new EventEmitter<number>()

  switchAreaLoading = false;

  constructor(
    protected el: ElementRef,
    protected projectCalcService: ProjectCalcService,
    protected deviceService: DeviceDetectorService,
    protected wsService: WsService
  ) {
  }

  ngOnInit(): void {
    this.cutGroups()

    this.areaName = this.area.name;

    this.nameUpdateSubj.pipe(
      debounceTime(250)
    ).subscribe(() => {
      this.projectCalcService.updateArea(this.pricingId, {
        id: this.area.id,
        name: this.area.name
      }).subscribe(() => {

      })
    })

    this.sumValueSubj = this.projectCalcService.sumValueSubj.pipe(
      debounceTime(100)
    ).subscribe(val => {
      this.sumValue = val.val;
      this.sumValueQty = val.qty;
    })

    this.areaUpdateSubj = this.projectCalcService.switchAreaSubj.subscribe(val => {
      this.cutGroups()
    })

    this.subToChanges()
  }

  cutGroups() {
    this.switchAreaLoading = true;

    timer(100).subscribe(emit => {
      this.miscAndAddonsGroups = []
      this.groupsWithoutAddons = []

      for (let i = 0; i < this.area.groups.length; i++) {
        if (this.area.groups[i].pricingCategory.categoryType === 'ADDONS' ||
          this.area.groups[i].pricingCategory.categoryType === 'MISC' ||
          this.area.groups[i].pricingCategory.categoryType === 'UPGRADES') {
          this.miscAndAddonsGroups.push(this.area.groups[i])
        }
        else{
          this.groupsWithoutAddons.push(this.area.groups[i])
        }
      }

      this.addCalcGroup()

      this.switchAreaLoading = false;
    })
  }

  addCalcGroup() {
    const newGroup = new PricingGroup()
    newGroup.id = -1;
    newGroup.name = 'Notes'
    newGroup.pricingCategory = new PricingCategory()
    newGroup.pricingCategory.id = -1;
    newGroup.pricingCategory.categoryType = 'UPGRADES'
    this.miscAndAddonsGroups.push(newGroup)
    //
  }

  // DO WITH INTERACTION TIME
  subToChanges() {
    this.wsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<PricingGroupItem>>('/topic/update/model.pricing.item.pricingitem', this)
      .subscribe(updateInfo => {
        this.projectCalcService.groupToUpdate.next(updateInfo)
      })
  }

  nameUpdate() {
    this.nameUpdateSubj.next()
  }

  deleteExtraELems() {
    const elems = document.getElementsByClassName('htContextMenu')
    const elemsSize = elems.length
    // tslint:disable-next-line:prefer-for-of
    for (let i = elemsSize - 1; i >= 0; i--) {
      elems[i].remove()
    }
  }

  ngOnDestroy() {
    this.deleteExtraELems();

    if (this.areaUpdateSubj) {
      this.areaUpdateSubj.unsubscribe()
      this.areaUpdateSubj = null
    }

    if (this.nameUpdateSubj) {
      this.nameUpdateSubj.unsubscribe()
      this.nameUpdateSubj = null
    }

    if (this.sumValueSubj) {
      this.sumValueSubj.unsubscribe()
      this.sumValueSubj = null
    }
    if (this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null
    }
  }

}
